import { Component, Input } from '@angular/core';
import { EEtatRegle } from 'apps/idl/src/model/EEtatRegle';
import { Regle } from 'apps/idl/src/model/Regle';

@Component({
    selector: 'di-information-popover',
    templateUrl: './information-popover.component.html',
    styleUrls: ['./information-popover.component.scss'],
})
export class InformationPopoverComponent{

    @Input() regles: Regle[];

    @Input() close = () => {};

    constructor() {}

    getIcon(etat: EEtatRegle) {
        switch (etat) {
            case EEtatRegle.valide:
                return 'check_circle';
            case EEtatRegle.invalide:
                return 'cancel';
            case EEtatRegle.non_applicable:
                return 'help';
            case EEtatRegle.information:
                return 'info';
            case EEtatRegle.erreur:
                return 'cancel';
            default:
                return 'info';
        }
    }

    getColor(etat: EEtatRegle) {
        switch (etat) {
            case EEtatRegle.valide:
                return 'Vert';
            case EEtatRegle.invalide:
                return 'Gris2';
            case EEtatRegle.non_applicable:
                return 'Gris2';
            case EEtatRegle.information:
                return 'Info';
            case EEtatRegle.erreur:
                return 'Error';
            default:
                return 'Gris2';
        }
    }
}
